import template from "./places_autocomplete.html";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

class PlacesAutocompleteController {
    /* @ngInject */
    constructor($document, $q, $element) {
        this.$document = $document;
        this.$q = $q;
        this.$element = $element;
    }

    $onInit() {
        let ctrl = this;

        ctrl.isEditing = !ctrl.readableLocation;

        ctrl.startEditing = function () {
            ctrl.isEditing = true;
            ctrl.$q.when().then(function () {
                setTimeout(function () {
                    let pacContainer = ctrl.$element[0].querySelector("#pac");
                    if (!pacContainer) {
                        return;
                    }

                    let inputElement = pacContainer.querySelector("input");
                    if (
                        inputElement &&
                        typeof inputElement.focus === "function"
                    ) {
                        inputElement.focus();
                    }
                }, 0);
            });
        };

        setOptions({
            key: process.env.GOOGLE_PUBLIC_API_KEY,
            v: "weekly",
            libraries: ["places"],
        });

        importLibrary("places").then(function (places) {
            let pacInputElement = ctrl.$element[0].querySelector("#pac");
            if (!pacInputElement) {
                return;
            }
            if (pacInputElement.childElementCount > 0) {
                return;
            }

            const placeAutocomplete = new places.PlaceAutocompleteElement();
            pacInputElement.appendChild(placeAutocomplete);
            placeAutocomplete.addEventListener(
                "gmp-select",
                function ({ placePrediction }) {
                    const place = placePrediction.toPlace();
                    ctrl.$q
                        .when(
                            place.fetchFields({
                                fields: [
                                    "displayName",
                                    "formattedAddress",
                                    "location",
                                    "addressComponents",
                                ],
                            }),
                        )
                        .then(function (placeData) {
                            ctrl.onPlaceUpdate({ place: placeData.place });

                            ctrl.readableLocation =
                                placeData.place.formattedAddress ||
                                placeData.place.displayName;

                            ctrl.isEditing = false;
                        });
                },
            );
        });
    }
}
export default {
    bindings: {
        onPlaceUpdate: "&",
        placeholder: "@",
        readableLocation: "@",
    },
    controller: PlacesAutocompleteController,
    template: template,
    name: "placesAutocomplete",
};
